import { EKwikUIAnimationPlayerType } from "./animation-player.definitions";

export const DEFAULT_VALUES = {
  config: {},
  id: "animation-player",
  player: EKwikUIAnimationPlayerType.LOTTIE
};

export const VALIDATE_KEY_VALUES = {
  config: true,
  id: true,
  player: true
};
